module.exports = __webpack_public_path__ + "img/fees_insights.36fc649f.svg";